import ZicassoChat from './zicasso-chat-container';

export default ZicassoChat;
